var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
'component',
'component__title',
_vm.size ? ("component__title--" + _vm.size) : '',
_vm.margin ? ("component__title--margin-" + _vm.margin) : '',
_vm.color ? ("component__title--" + _vm.color) : '',
_vm.underline ? "component__title--underline" : '',
_vm.raw ? "component__title--raw" : ''
]},[_c('div',{staticClass:"container custom--flex"},[_c('div',{staticClass:"columns is-variable"},[_c('div',{staticClass:"column"},[_c('span',[_vm._t("default")],2)])])])])}
var staticRenderFns = []

export { render, staticRenderFns }